import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  INVENTORY_PURCHASE_ORDER_SET_OUTLETS,
  INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE,
  INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE,
  INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN,
  INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN,
  INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS,
  INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL,
  INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM,
  INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM,
  INVENTORY_PURCHASE_ORDER_IS_LOADING,
  INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH,
  INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET,
  INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM,
  INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL,
  INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL,
  INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED,
  INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS
} from 'actions/inventory/purchaseOrder/constants'
let initialState = {
  outlets: [],
  selected_outlet: null,
  purchaseOrders: [],
  currentPage: null,
  totalPage: null,
  openRightColumn: false,
  purchaseOrderDetail: null,
  suppliers: [],
  rightColumnState: '', // for create po purpose
  showModalItem: false,
  addItems: {
    isLoading: false,
    items: [],
    firstItems: []
  },
  temporaryItem: null,
  confirmSubmitModal: {
    show: false,
    action: null
  },
  alreadyAddedItem: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case INVENTORY_PURCHASE_ORDER_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER:
      return {...state, purchaseOrders: payload.purchaseOrders}
    case INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.page}
    case INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.page}
    case INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true, rightColumnState: payload.rightColumnState}
    case INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL:
      return {...state, purchaseOrderDetail: payload.purchaseOrder}
    case INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS:
      return {...state, suppliers: payload.suppliers}
    case INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM:
      return {...state, showModalItem: true}
    case INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM:
      return {...state, showModalItem: false}
    case INVENTORY_PURCHASE_ORDER_IS_LOADING:
      return {...state, addItems: {...state.addItems, isLoading: payload.isLoading}}
    case INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH:
      return {...state, addItems: {...state.addItems, items: payload.items}}
    case INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS:
      return {...state, addItems: {...state.addItems, firstItems: payload.firstItems}}
    case INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET:
      return {...state, selected_outlet: payload.outletId}
    case INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM:
      return {...state, temporaryItem: payload.item}
    case INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL:
      return {...state, confirmSubmitModal: {show: false, action: null}}
    case INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL:
      return {...state, confirmSubmitModal: {show: true, action: payload.action}}
    case INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED:
      return {...state, alreadyAddedItem: payload.isAdded}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/inventory/purchaseOrder.js